/*!
	WSPayment
	Whitespace 2015
*/
var WSPayment = (function($form, settings) {
	var my;

	my = {
		ui: {},

		enable: function() {
			var locale;

			if (($form).length < 1) {
				return;
			}

			settings = window.ob_set(settings || {}, {
				'config': {
					'currency': '',
					'description': '',
					'image': '',
					'key': '',
					'label': '',
					'name': '',
					'locale': window.GLOBALS.language_code ? window.GLOBALS.language_code : 'en'
				}
			});

			// austrian isn't supported, use german.
			if(settings.config.locale == 'at') {
				settings.config.locale = 'de';
			}

			if (settings.config.type === 'stripe') {
				if (typeof(window.Stripe) !== 'undefined'){
					switch (window.Stripe.version) {
						case 2:
							my.stripeHandler = window.StripeCheckout.configure({
								'key':   settings.config.key,
								'image': settings.config.image,
								'token': my.tokenHandler,
								'locale': settings.config.locale
							});
							break;

						case 3:
							my.stripe = window.Stripe(settings.config.key);
							break;
					}
				} else {
					console.error('Stripe API does not appear to be loaded.');
				}
			}

			if(settings.config.selectors.submit_button !== 'undefined') {
				my.ui.$submit_button = $(settings.config.selectors.submit_button)
			} else {
				my.ui.$submit_button = false;
			}

			my.ui.$slow_loading = $('.frm-slow-loading-message');

			// form validation handler
			my.formHandler();
		},

		formHandler: function() {
			// block the default submit behaviour,
			// stripe on chrome ios require click event to trigger
			var options = {
				'submit': {
					'callback': function() {return false;}
				}
			};

			options.popup = {
				'alignment': window.WS.Form.Alignments.bottom_right,
				'margin': 10
			};
			options.field = {
				'popup': {
					'alignment': window.WS.Form.Alignments.bottom_right
				}
			};

			my.ui.form = new window.WS.Form($form, options, {
				'first_name': {
					'require': true,
					'max_len': 30
				},
				'last_name': {
					'require': true,
					'max_len': 30
				},
				'email': {
					'require': true,
					'type': window.WS.Form.ValueTypes.Email,
					'popup': {
						'alignment': window.WS.Form.Alignments.bottom_right
					}
				},
				'updates_email': {
					'require': true,
					'popup': {
						'alignment': window.WS.Form.Alignments.bottom_right
					}
				},
				'updates_post': {
					'require': true,
					'popup': {
						'alignment': window.WS.Form.Alignments.bottom_right
					}
				},
				'plates[0][name]': {
					'require': true,
					'popup': {
						'alignment': window.WS.Form.Alignments.top_left
					}

				},
				'plates[0][quantity]': {
					'require': true,
					'type': window.WS.Form.ValueTypes.Number,
					'min': 1,
					'popup': {
						'alignment': window.WS.Form.Alignments.top_left
					}
				}
			});

			window.setTimeout(function() {
				if ($form.find('.g-recaptcha').length > 0) {
					my.ui.form.add_field("g-recaptcha-response", {
						"require": true
					});

					window.recaptchaCallback = function(token) {
						if (token !== "") {
							$(".field.captcha p.error").addClass("v-hidden");
						}
					}

					window.recaptchaExpire = function() {
						my.ui.form.remove_field("g-recaptcha-response");
					}
				}
			}, 3000);

			$("input[name='updates_post']").change(function() {
				$addr_fields = $(".address-fields");

				if (this.value === "Yes") {
					$addr_fields.removeClass("hidden");
					my.ui.form.add_field("updates_address", {
						"require": true
					});
					my.ui.form.add_field("updates_postcode", {
						"require": true
					});
					my.ui.form.add_field("updates_country", {
						"require": true
					});

					if ($("input[name='state']").is(":visible")) {
						my.ui.form.add_field("updates_state", {
							"require": true
						});
					}
				} else {
					$addr_fields.addClass("hidden");
					my.ui.form.remove_field("updates_address", {});
					$("textarea[name='updates_address']").val("");

					my.ui.form.remove_field("updates_postcode", {});
					$("input[name='updates_postcode']").val("");

					my.ui.form.remove_field("updates_country", {});
					$("#select_country option[value='']").attr("selected", true);
					$("#proxy-for-select_country span").html("Please select your country");

					my.ui.form.remove_field("updates_state", {});
					$("input[name='updates_state']").val("");
				}
			});

			if (my.ui.$submit_button) {
				my.ui.$submit_button.on('click', function(e){
					e.preventDefault();
					//clear any placeholder inputs
					my.ui.form.clearPlaceholders();
					if (my.ui.form.validate()) {
						//submit
						my.ui.$submit_button.addClass('loading');
						my.ui.$submit_button.attr('disabled', 'disabled');

						if (my.ui.$slow_loading.length) {
							window.setTimeout(function() {
								my.ui.$slow_loading.fadeIn(400);
							}, 5000);
						}

						my.submitHandler();
					} else {
						if ($form.find('.g-recaptcha').length > 0) {
							var recaptcha_result = my.ui.form.validate_field('g-recaptcha-response');

							if (! recaptcha_result.valid) {
								if (recaptcha_result.element.val() === '') {
									recaptcha_result.element.closest('.field.captcha').find('.error').removeClass('v-hidden');
								}
							} else {
								recaptcha_result.element.closest('.field.captcha').find('.error').addClass('v-hidden');
							}
						}
						//restore any placeholder inputs
						my.ui.form.restorePlaceholders();
						my.ui.form.report();
					}
				});
			}

			if ($('#xmas-campaign').length) {
				window.xmas_donation_form = my.ui.form;
			}
		},

		submitHandler: function() {
			if (settings.config.type === 'paypal') {
				return;
			}

			var amount, data, gatewayPercent, gatewayFlatFee, gatewayVAT, gatewayCharge, transactionDetails;

			data = $form.serializeObject();
			data.amount = data.amount.replace(window.GLOBALS.thousands_seperator,'T').replace(window.GLOBALS.decimal_seperator,'D');
			data.amount = data.amount.replace('T','').replace('D','.');
			amount = parseFloat(Number(data.amount.replace(/[^0-9\.]+/g, ''))) * 100;

			// If 0 value passed throw error
			if (amount === 0) {
				// this.message(window.TRANSLATE['wsfp_required'], $('#frm-donate .button'), { 'popup' : { 'type' : WS.Form.MsgTypes.Error } });
				$('#frm-project-donate-amount').parent().addClass('required');
				$('html, body').animate({scrollTop: $('#frm-project-donate-amount').parent().offset().top}, 300);
				return;
			} else {
				//if the user is covering the charge increase the amount
				if(data.cover_payment_charge) {
					gatewayFlatFee = parseFloat(window.GLOBALS.gateway_charge_flat_fee)*100;
					gatewayPercent = parseFloat(window.GLOBALS.gateway_charge_percent);
					gatewayVAT = parseFloat(window.GLOBALS.gateway_charge_vat);
					if(gatewayVAT > 0) {
						gatewayPercent = gatewayPercent + ((gatewayPercent*gatewayVAT)/100);
						gatewayFlatFee = gatewayFlatFee + ((gatewayFlatFee*gatewayVAT)/100);
					}
					gatewayCharge = (amount * gatewayPercent)/100;
					gatewayCharge += gatewayFlatFee;

					gatewayCharge = Math.round(gatewayCharge);

					amount += gatewayCharge;
				}

				if ('stripeHandler' in my) {
					my.stripeHandler.open({
						'address': true,
						'allowRememberMe': false,
						'amount': amount,
						'email': data.email,

						// module settings
						'currency':    settings.config.currency,
						'description': settings.config.description,
						'name':        settings.config.name,
						'panelLabel':  settings.config.label + ' {{amount}}'
					});

					$('#frm-project-donate-amount').parent().removeClass('required');
				} else if ('stripe' in my) {
					$.post($form.prop('action'), data)
						.done(function(response) {
							if (response.status === 'success') {
								my.checkoutSessionHandler(response.data);
							} else {
								console.error(response);
							}
						})
						.fail(function() {
							console.error('Something went wrong when submitting data to the server.');
						});
				}
			}

			return false;
		},

		checkoutSessionHandler: function(data) {
			my.stripe.redirectToCheckout({
				sessionId: data.checkout_session_id
			}).then(function (result) {
				console.log(result);
			});
		},

		tokenHandler: function(token) {
			if (settings.config.type === 'paypal') {
				return;
			}

			var data = $form.serializeObject();
			data.token = token.id;
			data.response = token;

			// disable the button at this point
			$form.find('.button').addClass('loading');
			$form.find('.button').attr('disabled', 'disabled');

			my.request = $.ajax($form.prop('action'), {
				'method': 'post',
				'data': data,
				'dataType': 'json'
			}).done(function(response) {
				my.responseHandler(response);
			});
		},

		responseHandler: function(data) {
			$form.find('.button').addClass('loading');
			$form.find('.button').attr('disabled', 'disabled');

			my.request = $.ajax(data.callback.success, {
				'method': 'get',
				'data': data,
				'dataType': 'json'
			}).done(function(redirect) {
				window.location.replace(redirect);
			});
		}
	};

	my.enable();
});


function getQueryVariable(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i=0;i<vars.length;i++) {
		var pair = vars[i].split("=");
		if (pair[0] == variable) {
			return pair[1];
		}
	}
	return '';
}

(function() {
	if (window.TRANSLATE) {
		window.WS.Form.Messages = {
			'general_error': window.TRANSLATE.wsfp_required,
			'field_value': window.TRANSLATE.wsfp_form_field_value,
			'field_mismatch': window.TRANSLATE.wsfp_form_field_mismatch,
			'tab_step_prefix': window.TRANSLATE.wsfp_form_tab_step_prefix,
			'type_email': window.TRANSLATE.wsfp_form_type_email,
			'type_number': window.TRANSLATE.wsfp_form_type_number,
			'type_regex': window.TRANSLATE.wsfp_form_type_regex,
			'type_date': window.TRANSLATE.wsfp_form_type_date,
			'value_min': window.TRANSLATE.wsfp_form_value_min,
			'value_max': window.TRANSLATE.wsfp_form_value_max,
			'value_min_len': window.TRANSLATE.wsfp_form_value_min_len,
			'value_max_len': window.TRANSLATE.wsfp_form_value_max_len,
			'did_you_mean': window.TRANSLATE.wsfp_form_did_you_mean
		};
	}

	if ($('#frm-donate')) {
		new WSPayment($('#frm-donate'), {
			'config': {
				'type': window.GLOBALS.payment_type,
				'currency': window.GLOBALS.currency_code,
				'key':  window.GLOBALS.stripe_api_key_pub,
				'label': window.TRANSLATE.wsfp_donate,
				'selectors': {
					'submit_button': "#frm-donate button[type='submit']"
				}
			}
		});
	}

	$('.currency-symbol')
		.on('keydown', function(e) {
			if ((!event.shiftKey && !event.ctrlKey && !event.altKey) && (
				// numbers
				$.inArray(event.keyCode, [44, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105]) >= 0 ||
				// special chars
				$.inArray(event.keyCode, [46, 8, 37, 39, 35, 36, 9]) >= 0 ||
				// decimals
				$.inArray(event.keyCode, [190, 110]) >= 0 ||
				// commas
				$.inArray(event.keyCode, [188]) >= 0
			) === false) {
				e.preventDefault();
			}
		})
		.on('focus', function() {
			if ($(this).val() == '1.00' || $(this).val() == '1,00') {
				$(this).val('');
			}
		})
		.on('blur', function() {
			var options = {};
			options.suppressCurrencySymbol = true;
			if ($(this).parents('.amount').length === 0) {
				options.symbol = window.GLOBALS.currency_symbol+window.GLOBALS.after_currency_symbol;
			}
			options.region = window.GLOBALS.country_code;
			if($(this).hasClass('with-symbol')) {
				options.suppressCurrencySymbol = false;
			}
			$(this).formatCurrency(options);

			if ($(this).val().match(/^[0,.]+$/)) {
				$(this).val('');
			}
		}
	);

	if ($('#frm-donate-external').length > 0) {
		var wsform;

		wsform = new window.WS.Form($('#frm-donate-external'), {
			'submit': {
				'callback': function() {
					$.ajax(window.GLOBALS.ajax_url,{
						data: $('#frm-donate-external').serialize(),
						method: 'get',
						success: function(response) {
							if ($('#bboxdonation_recurrence_ddFrequency')) {
								if (getQueryVariable('type') === 'yearly') {
									$('#bboxdonation_recurrence_ddFrequency').val('5');
								}
							}

							if (window.GLOBALS.country_code == 'GB' || window.GLOBALS.country_code == 'CA' || window.GLOBALS.country_code == 'DE') {
								if(window.GLOBALS.country_code == 'DE' && WS.JSMedia.run([['screen','(max-width: 700px)']])) {
									location.href = 'https://spendenformeals.de/formular/spende.php?amount='+getQueryVariable('amount');
								} else if (window.GLOBALS.country_code == 'GB' && response.type !== "single") {
									location.href = 'https://secure.edirectdebit.com/Marys-Meals/donate/Desktop-Form-Page/';
								} else {
									$('#frm-donate-external').hide();

									if (window.GLOBALS.country_code == 'CA') {
										var frequency = $('*[data-donation-frequency]').val();
										var iframe_src = $('input[name="iframe-src"]').val();
										var iframe_src_monthly = $('input[name="iframe-src-monthly"]').val();

										switch (frequency) {
											case 'monthly':
												$('#etapIframe').prop('src', iframe_src_monthly);
												break;
												
											default:
												$('#etapIframe').prop('src', iframe_src);
												break;
										}

										$('#oe-donate-form').show();
									} else {
										$('#oe-donate-form').show();
										$('#bboxdonation_billing_txtEmail').val($('#frm-donate-external input[name=email]').val());
									}
								}

							} else if (window.GLOBALS.country_code == 'US') {
								location.href = 'https://54971.thankyou4caring.org/sslpage.aspx?pid=298&amount=' + $('#frm-donate-external input[name=amount]').val().replace(window.GLOBALS.currency_symbol, '').replace(window.GLOBALS.after_currency_symbol, '');
							}
						}
					});
					return false;
				}
			},
			popup: {
				'alignment': window.WS.Form.Alignments.bottom_right,
				'margin': 10
			},

		},{
			'amount': {
				'require': true
			},
			'email': {
				'require': true,
				'type': window.WS.Form.ValueTypes.Email,
				'cascade': {
					'fields': {
						'confirm_email': {
							'require': true,
							'type': WS.Form.ValueTypes.Email,
							'duplicate_of': 'email',
							'messages': {
								'mismatch': window.TRANSLATE.wsfp_email_mismatch
							}
						}
					}
				}
			},
			'updates_email': {
				'require': true,
				'popup': {
					'alignment': window.WS.Form.Alignments.bottom_right
				}
			},
			'updates_post': {
				'require': true,
				'popup': {
					'alignment': window.WS.Form.Alignments.bottom_right
				}
			},
		});

		$("input[name='updates_post']").change(function() {
			$addr_fields = $(".address-fields");

			if (this.value === "Yes") {
				$addr_fields.removeClass("hidden");
				wsform.add_field("updates_address", {
					"require": true
				});
				wsform.add_field("updates_postcode", {
					"require": true
				});
				wsform.add_field("updates_country", {
					"require": true
				});

				if ($("input[name='state']").is(":visible")) {
					wsform.add_field("updates_state", {
						"require": true
					});
				}
			} else {
				$addr_fields.addClass("hidden");

				wsform.remove_field("updates_address", {});
				$("textarea[name='updates_address']").val("");

				wsform.remove_field("updates_postcode", {});
				$("input[name='updates_postcode']").val("");

				wsform.remove_field("updates_country", {});
				$("#select_country option[value='']").attr("selected", true);
				$("#proxy-for-select_country span").html("Please select your country");

				wsform.remove_field("updates_state", {});
				$("input[name='updates_state']").val("");
			}
		});

		window.setTimeout(function() {
			if ($('#frm-donate-external').find($(".g-recaptcha")).length > 0) {
				wsform.add_field("g-recaptcha-response", {
					"require": true
				});

				window.recaptchaCallback = function(token) {
					if (token !== "") {
						$(".field.captcha p.error").addClass("v-hidden");
					}
				}

				window.recaptchaExpire = function() {
					wsform.remove_field("g-recaptcha-response");
				}
			}
		}, 3000);

		$("#frm-donate-external").bind("form:error", function(event, form, faults) {
			$(faults).each(function(index, elem) {
				if (elem["name"] === "g-recaptcha-response") {
					if ($(elem["element"][0]).val() === "") {
						$(elem["element"][0]).closest(".field.captcha").find(".error").removeClass("v-hidden");
					}
				}
			});
		});
	}

})();
